(function () {
	const _hideButton = document.getElementById('mobile-menu-hide-button');
	const _showButton = document.getElementById('mobile-menu-show-button');
	const _menu = document.getElementById('mobile-menu');
	
	if (!_showButton || !_menu) {
		return;
	}
	
	function init() {
		_showButton.addEventListener('click', show);
		_hideButton.addEventListener('click', hide);
		_menu.addEventListener('blur', blur, true);
	}
	
	function blur(event) {
		const _target = event.relatedTarget || event.currentTarget.firstChild.ownerDocument.activeElement;
		
		if (!util.hasParent(_target, _menu)) {
			event.preventDefault();
			event.target.focus();
		}
	}
	
	function hide() {
		document.documentElement.style.overflowY = '';
		
		_showButton.setAttribute('aria-expanded', 'true');
		util.removeClass(_menu, 'is-visible');
		_menu.setAttribute('aria-hidden', 'true');
		
		_showButton.focus();
	}
	
	function show() {
		document.documentElement.style.overflowY = 'hidden';
		
		_showButton.setAttribute('aria-expanded', 'true');
		util.addClass(_menu, 'is-visible');
		_menu.setAttribute('aria-hidden', 'false');
		
		_hideButton.focus();
	}
	
	init();
}());